<template>
    <div class="galery_block">
        <div class="figure_list">
            <figure v-for="(image, index) in value" :key="index">
                <picture v-full-image-path="image" />

                <a :href="link(image)" data-fancybox="gallery">
                    <div class="gallery_title">
                        צפה בגלרייה
                    </div>
                </a>
            </figure>
        </div>
    </div>
</template>

<script>
import { mapActions } from 'vuex';
import getMediaUrl from '@/helpers/getMediaUrl';

export default {
    props: {
        value: {
            type: Array,
            required: true
        }
    },

    mounted() {
        this.initFancybox();
    },

    methods: {
        ...mapActions({
            initFancybox: 'scripts/initFancybox'
        }),

        link(image) {
            return getMediaUrl(image);
        }
    }
};
</script>
